import store from "./plugins/store";
import {Auth, Locale} from "./modules/utils";
import i18n from "./plugins/i18n";

// TODO: zlikwidować powielony kod
window._ = require('lodash');
window.qs = require('qs');
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.baseURL = process.env.MIX_API_URL;

window.apiAxios = window.axios.create({
    baseURL: process.env.MIX_API_URL + 'api/',
    xsrfCookieName: process.env.MIX_XSRF_PREFIX.concat('-XSRF-TOKEN'),
    xsrfHeaderName: process.env.MIX_XSRF_PREFIX.concat('-X-XSRF-TOKEN')
});

window.authAxios = window.axios.create({
    baseURL: process.env.MIX_API_URL + 'api/auth/',
    xsrfCookieName: process.env.MIX_XSRF_PREFIX.concat('-XSRF-TOKEN'),
    xsrfHeaderName: process.env.MIX_XSRF_PREFIX.concat('-X-XSRF-TOKEN')
});

Locale.setCurrencyNumberFormat(i18n.locale);
Locale.setDateTimeFormat(i18n.locale);


window.axios.interceptors.request.use(config => {
    store.commit("resetValidation");
    store.commit("closeSnackbarMessage");
    return config;
}, error => {
    return Promise.reject(error);
});

window.axios.interceptors.response.use(response => response, error => {
    if (!error.response) {
        store.commit(
            "showSnackbarError",
            i18n.t('bootstrap.oops_something_went_wrong')
        );

        return Promise.reject(error);
    }
    if (error.response.status === 401) {
        Auth.clear();
        Auth.redirectToLogin();
    } else if (error.response.status === 422) {
        store.commit("setValidationErrors", error.response.data.errors ?? {});
        store.commit("setValidationMessage", error.response.data.message ?? null);
    } else {
        store.commit(
            "showSnackbarError",
            i18n.t('bootstrap.oops_something_went_wrong')
        );
    }
    return Promise.reject(error);
});

/**
 * Create custom axios instances
 */

window.apiAxios = window.axios.create({
    baseURL: process.env.MIX_API_URL + 'api/',
    xsrfCookieName: process.env.MIX_XSRF_PREFIX.concat('-XSRF-TOKEN'),
    xsrfHeaderName: process.env.MIX_XSRF_PREFIX.concat('-X-XSRF-TOKEN')
});

window.authAxios = window.axios.create({
    baseURL: process.env.MIX_API_URL + 'api/auth/',
    xsrfCookieName: process.env.MIX_XSRF_PREFIX.concat('-XSRF-TOKEN'),
    xsrfHeaderName: process.env.MIX_XSRF_PREFIX.concat('-X-XSRF-TOKEN')
});

window.authAxios.interceptors.response.use(response => response, error => {
    if (!error.response) {
        store.commit(
            "showSnackbarError",
            i18n.t('bootstrap.oops_something_went_wrong')
        );

        return Promise.reject(error);
    }
    if (error.response.status === 401) {
        Auth.clear();
        Auth.redirectToLogin();
    } else if (error.response.status === 422) {
        store.commit("setValidationErrors", error.response.data.errors ?? {});
        store.commit("setValidationMessage", error.response.data.message ?? null);
    } else {
        store.commit(
            "showSnackbarError",
            error.response.data.message || i18n.t('bootstrap.oops_something_went_wrong')
        );
    }
    return Promise.reject(error);
});
window.apiAxios.interceptors.response.use(response => response, error => {
    if (error instanceof axios.Cancel) {
        return Promise.reject(error);
    }

    if (!error.response) {
        store.commit(
            "showSnackbarError",
            i18n.t('bootstrap.oops_something_went_wrong')
        );

        return Promise.reject(error);
    } else if (error.response.status === 401) {
        Auth.clear();
        Auth.redirectToLogin();
    } else if (error.response.status === 422) {
        store.commit("setValidationErrors", error.response.data.errors ?? {});
        store.commit("setValidationMessage", error.response.data.message ?? null);
    } else {
        store.commit(
            "showSnackbarError",
            error.response.data.message || i18n.t('bootstrap.oops_something_went_wrong')
        );
    }
    return Promise.reject(error);
});
